var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pui-lightbox", {
    ref: _vm.REF_CONSTANTS.LIGHTBOX,
    attrs: { "default-header-label": _vm.unitName },
    scopedSlots: _vm._u([
      {
        key: "lightbox-header",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "completeness-check-modal__header" },
              [
                _c("pui-headline", { attrs: { type: "h3" } }, [
                  _vm._v(" " + _vm._s(_vm.unitName) + " "),
                ]),
                _c("span", [_vm._v(_vm._s(_vm.completenessDetails))]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "default",
        fn: function () {
          return [
            _c(
              "pui-loader",
              {
                staticClass: "completeness-check-modal__loader",
                attrs: { promise: _vm.completenessCheckDetailsPromise },
              },
              [
                _c(
                  "pui-tabs",
                  { staticClass: "completeness-check-modal__tabs" },
                  [
                    _c(
                      "pui-tab",
                      {
                        attrs: {
                          title: _vm.$t(
                            "completenessCheckDetailModal.tabs.details"
                          ),
                        },
                      },
                      [
                        _c("completeness-check-modal-details-tab", {
                          attrs: {
                            "completeness-detail-payload":
                              _vm.completenessDetailsPayload,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "pui-tab",
                      {
                        attrs: {
                          title: _vm.$t(
                            "completenessCheckDetailModal.tabs.comments"
                          ),
                        },
                      },
                      [_c("completeness-check-modal-comments-tab")],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }